module.exports = __webpack_public_path__ + "static/media/cv.4df6ca56.pdf";